import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-b2b-banner',
  templateUrl: './b2b-banner.component.html',
  styleUrls: ['./b2b-banner.component.scss']
})
export class B2bBannerComponent implements OnInit {

  @Input() data: any = {}
  lang: string = 'pt'

  icons = [
    '/assets/images/b2b-banner/icon-cuidado.svg',
    '/assets/images/b2b-banner/icon-instalacao.svg',
    '/assets/images/b2b-banner/icon-pureza.svg',
  ]

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.lang = this.route.snapshot.params.lang
  }

  get primaryHref(): string {
    return this.data?.banner_primary_link
      ? '/' + this.lang + '/b2b' + this.data.banner_primary_link
      : '#formulario-b2b'
  }

  scrollToForm(event: Event): void {
    const hashIndex = this.primaryHref.indexOf('#')
    if (hashIndex === -1) {
      return
    }
    const target = document.getElementById(this.primaryHref.slice(hashIndex + 1))
    if (!target) {
      return
    }
    event.preventDefault()
    target.scrollIntoView({ behavior: 'smooth' })
  }

}
